exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-box{position:relative;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:100px;margin-bottom:15px;padding:30px;border:1px solid #5f8f93;cursor:pointer}@media screen and (min-width:768px){.help-box{height:150px;margin-bottom:30px}}.help-box div{-ms-flex-positive:1;flex-grow:1}@media screen and (min-width:768px){.help-box:hover .help-box__title{-ms-transform:translateY(-10px);transform:translateY(-10px)}.help-box:hover .help-box__arrow{-ms-transform:translateY(-10px) translateX(-50%);transform:translateY(-10px) translateX(-50%);opacity:1}}.help-box__title{display:block;-ms-transform:translateY(0);transform:translateY(0);transition:transform .3s ease}.help-box__arrow{position:absolute;bottom:10px;left:50%;-ms-transform:translateY(0) translateX(-50%);transform:translateY(0) translateX(-50%);opacity:0;transition:opacity .3s ease .1s,transform .3s ease .1s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/helpboxes/helpbox/helpbox.styl
// module id = 497
// module chunks = 0